export var getMask = function getMask(_ref) {
  var size = _ref.size,
      opacityTop = _ref.opacityTop,
      opacityBottom = _ref.opacityBottom;
  return "linear-gradient(180deg, rgba(255, 255, 255, ".concat(opacityTop, "), black) center top / 100% ").concat(size, "px no-repeat,\n  linear-gradient(180deg, black, black) center ").concat(size, "px / 100% calc(100% - ").concat(size * 2, "px) no-repeat,\n  linear-gradient(180deg, black, rgba(255, 255, 255, ").concat(opacityBottom, ")) center bottom / 100% ").concat(size, "px no-repeat");
};